import React from 'react';
import PropTypes from 'prop-types';
import { NUGGET, RUBY, SAPPHIRE, WCHIP, WSCORE } from 'utils/constants';
import { formatNumber } from 'utils/formatting';
import NuggetIcon from 'resources/icons-currency-nugget-sml.png';
import RubyIcon from 'resources/icons-currency-ruby-sml.png';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import WChipIcon from 'resources/ui-icon-wchip.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import '../WStoreGems/WStoreGems.css';

const GEM_ICON = {
  [NUGGET]: NuggetIcon,
  [RUBY]: RubyIcon,
  [SAPPHIRE]: SapphireIcon,
  [WCHIP]: WChipIcon,
  [WSCORE]: WScoreIcon
};

const GEM_TITLE = {
  [NUGGET]: 'Nuggets',
  [RUBY]: 'Rubies',
  [SAPPHIRE]: 'Sapphires',
  [WCHIP]: 'WChips',
  [WSCORE]: 'WScore'
};

const GEM_ALT_TEXT = {
  [NUGGET]: 'Nuggets Cost',
  [RUBY]: 'Ruby Cost',
  [SAPPHIRE]: 'Sapphire Cost',
  [WCHIP]: 'WChip Cost',
  [WSCORE]: 'WScore Cost'
};

function getNumberLength(number) {
  return number ? number.toString().length : 0;
}

function getFontSize(number) {
  const len = getNumberLength(number);

  return len >= 7 ? 'wscore-cost-xs' : len >= 4 ? 'wscore-cost-s' : '';
}

function WStoreGem({ gemType, amount, large }) {
  return (
    <div className={`wstore-gem-item ${large ? 'large' : ''}`}>
      <img
        src={GEM_ICON[gemType]}
        alt={GEM_ALT_TEXT[gemType]}
        title={GEM_TITLE[gemType]}
        className={`wscore-gem-icon ${large ? 'large' : ''}`}
      />
      <div className={`wscore-cost ${large ? 'large' : getFontSize(amount)}`}>
        {formatNumber(amount)}
      </div>
    </div>
  );
}

WStoreGem.propTypes = {
  gemType: PropTypes.string,
  amount: PropTypes.number
};

export default WStoreGem;
